import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const TIER_NAMES = { 1: 'Starter', 2: 'Growth', 3: 'Premium' };
const TIER_COLOR = { 1: '#6B7280', 2: '#f97316', 3: '#8B5CF6' };

const TIER_FEATURES = {
  2: ['Rezervasiya sistemi', 'QR kupon / promo yaratma', 'GastroMatch görünürlüyü', 'Aylıq performans hesabatı'],
  3: ['Prioritet sıralama', '"Verified Partner" badge', 'Çox lokasiya dəstəyi', 'Tam analitika + export', 'Dedicated account manager'],
};

export default function LockedFeaturePage({ requiredTier, featureName }) {
  const { business } = useAuth();
  const navigate = useNavigate();
  const currentTier = business?.premium_tier || 1;
  const tierColor = TIER_COLOR[requiredTier] || '#f97316';
  const tierName = TIER_NAMES[requiredTier] || 'Growth';

  return (
    <div style={s.wrap}>
      <div style={s.card}>
        {/* Lock icon */}
        <div style={{ ...s.lockCircle, background: tierColor + '18', border: `2px solid ${tierColor}44` }}>
          <span style={{ fontSize: 40 }}>🔒</span>
        </div>

        <h2 style={s.title}>
          {featureName || 'Bu xüsusiyyət'} kiliddədir
        </h2>
        <p style={s.sub}>
          Bu bölməyə daxil olmaq üçün ən azı{' '}
          <strong style={{ color: tierColor }}>{tierName}</strong> planına keçməlisiniz.
        </p>

        {/* Current vs Required */}
        <div style={s.compareRow}>
          <div style={s.compareBox}>
            <div style={{ ...s.compareLabel, color: '#888' }}>Cari plan</div>
            <div style={{ ...s.compareTier, color: TIER_COLOR[currentTier] || '#888' }}>
              {TIER_NAMES[currentTier] || 'Starter'}
            </div>
          </div>
          <div style={s.arrow}>→</div>
          <div style={{ ...s.compareBox, background: tierColor + '12', border: `1px solid ${tierColor}44` }}>
            <div style={{ ...s.compareLabel, color: tierColor }}>Tələb olunan</div>
            <div style={{ ...s.compareTier, color: tierColor }}>{tierName}</div>
          </div>
        </div>

        {/* Features unlocked */}
        {TIER_FEATURES[requiredTier] && (
          <div style={s.featuresBox}>
            <div style={s.featuresTitle}>{tierName} planında açılır:</div>
            <ul style={s.featuresList}>
              {TIER_FEATURES[requiredTier].map((f, i) => (
                <li key={i} style={s.featureItem}>
                  <span style={{ color: tierColor, marginRight: 8 }}>✓</span>
                  {f}
                </li>
              ))}
            </ul>
          </div>
        )}

        <button
          style={{ ...s.upgradeBtn, background: tierColor }}
          onClick={() => navigate('/select-package')}
        >
          Planı Yüksəlt
        </button>

        <button
          style={s.backBtn}
          onClick={() => navigate('/dashboard')}
        >
          ← Dashboarda qayıt
        </button>
      </div>
    </div>
  );
}

const s = {
  wrap: {
    minHeight: '80vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
    background: '#f5f6fa',
  },
  card: {
    background: '#fff',
    borderRadius: 20,
    padding: '40px 36px',
    maxWidth: 440,
    width: '100%',
    textAlign: 'center',
    boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
  },
  lockCircle: {
    width: 88,
    height: 88,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 20px',
  },
  title: {
    fontSize: 22,
    fontWeight: 800,
    color: '#1a1a2e',
    margin: '0 0 10px',
  },
  sub: {
    fontSize: 14,
    color: '#666',
    lineHeight: 1.6,
    margin: '0 0 24px',
  },
  compareRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 16,
    marginBottom: 24,
  },
  compareBox: {
    flex: 1,
    background: '#f8f9fa',
    border: '1px solid #e0e0e0',
    borderRadius: 12,
    padding: '12px 16px',
  },
  compareLabel: {
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: 1,
    textTransform: 'uppercase',
    marginBottom: 4,
  },
  compareTier: {
    fontSize: 18,
    fontWeight: 800,
  },
  arrow: {
    fontSize: 20,
    color: '#ccc',
    flexShrink: 0,
  },
  featuresBox: {
    background: '#f8f9fa',
    borderRadius: 14,
    padding: '16px 20px',
    marginBottom: 24,
    textAlign: 'left',
  },
  featuresTitle: {
    fontSize: 12,
    fontWeight: 700,
    color: '#888',
    textTransform: 'uppercase',
    letterSpacing: 1,
    marginBottom: 10,
  },
  featuresList: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
  },
  featureItem: {
    fontSize: 13,
    color: '#444',
    padding: '4px 0',
    display: 'flex',
    alignItems: 'center',
  },
  upgradeBtn: {
    display: 'block',
    width: '100%',
    padding: '14px',
    borderRadius: 12,
    border: 'none',
    color: '#fff',
    fontSize: 15,
    fontWeight: 700,
    cursor: 'pointer',
    marginBottom: 12,
    letterSpacing: 0.3,
  },
  backBtn: {
    display: 'block',
    width: '100%',
    padding: '12px',
    borderRadius: 12,
    border: '1px solid #e0e0e0',
    background: 'transparent',
    color: '#888',
    fontSize: 14,
    cursor: 'pointer',
  },
};
